import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['contactSalesMqlClicked', 'variant_trial'] as const;

export const abTestEvents = getMappedEvents([...EVENTS]);
